export default "__VITE_ASSET__D$UyAlAS__"